// extracted by mini-css-extract-plugin
export var logo = "freshers2021-module--logo--HJxu8";